////////////////////////////////////////////////////////////
//  Program: TemplateForm.jsx                             //
//  Application:  Template Form                           //
//  Option: List of Template                              //
//  Developer: kiran singh                                //
//  Date: 2022-04-01                                      //
////////////////////////////////////////////////////////////
import React, { Component } from "react";
import { Form, Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import SimpleReactValidator from "simple-react-validator";
import PropertyService from "../../services/PropertyService";
import ChecklistService from "../../services/ChecklistService";
import pluswIcon from "./../../assets/images/plus.svg";
import EditpenIcon from "./../../assets/images/edit-pen-icon.svg";
import deleteicon from "../../assets/images/delete-gray.svg";
import back from "./../../assets/images/back.svg";
import Alerts from "../common/Alerts";
import Select from "react-select";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import LinkModal from "../LinkModal";
import RiskLevelConfig from "../common/RiskLevelConfig";
export class ChecklistForm extends Component {
  constructor(props) {
    super(props);
    this.validator = new SimpleReactValidator({ autoForceUpdate: this });
    this.state = {
      showModal: false,
      range: null,
      url: "",
      text: "",
      isEditing: false,
      loading: false,
      showAlertModal: false,
      alertModalType: "",
      alertModalTitle: "",
      alertModalMessage: "",
      input: {},
      errors: {},
      status_id: true,
      slug: this.props.match.params.slug,
      isSubmit: false,
      isDelete: false,
      sort_order: "",
      pathname: window.location.pathname,
      toggleSwitchDark2: true,
      showWeightInput: false,
      zoneTypeList: [],
      propertyList: [],
      formValues: [
        { category_name: "", task_name: [{ name: "", viewMode: false }] },
      ],
      userData: global.userData ? global.userData : {},

      configData: [],
      showRiskLevelInfo: false,
      allowRiskLevelConfig: false, // Allow Risk Level
      riskConfigData: [],
      deleteTaskModal: false,
      pendingDeleteTask: null,
      excludeTaskModal: false,
      pendingExcludeTask: null,
      deleteCategoryModal: false,
      pendingDeleteCategory: null,
    };
    this.quillRefs = [];
    this.saveOrUpdateTemplate = this.saveOrUpdateTemplate.bind(this);
    this.changeHandler = this.changeHandler.bind(this);
    this.opendeleteModal = this.opendeleteModal.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleLinkClick = this.handleLinkClick.bind(this);
    this.handleModalRemove = this.handleModalRemove.bind(this);
    this.handleChangeQuill = this.handleChangeQuill.bind(this);
    this.handleModalClose = this.handleModalClose.bind(this);
    this.handleModalSubmit = this.handleModalSubmit.bind(this);
    this.handleInputFocus = this.handleInputFocus.bind(this);
    this.handleWeightChange = this.handleWeightChange.bind(this);
  }

  
  rowData(data) {
    this.setState({ configData: data });
  }

  handleConfigChange = (data) => {
    this.setState({ configData: data });
  };

  async getProperty(queryString = "") {
    var propertyList = [];
    var propertyListData = [];
    let res = await PropertyService.getPropertyList(
      "is_dropdown=1" + (queryString ? "&" + queryString : "")
    );
    if (global.successStatus.includes(res.status)) {
      propertyList = res.data ? res.data : [];
    }
    if (propertyList.length > 0) {
      propertyList.forEach((item) => {
        propertyListData.push({
          label: item.property_name,
          value: item.slug,
        });
      });
    }
    this.setState({
      propertyList: propertyListData,
    });
  }
  customValidate() {
    let isValid = true;
    return isValid;
  }

  setOpen(open, e) {
    this.setState({ open: open });
    this.setState({ eventKey: e.target.eventKey });
  }
  changeHandler = (event) => {
    let input = this.state.input;
    let value =
      event.target.type === "checkbox"
        ? event.target.checked
        : event.target.value;
    value = event.target.type === "radio" ? parseInt(value) : value;

    input[event.target.name] = value;
    this.setState({ [event.target.name]: value, input: input });
    // Validate
    this.validator.showMessageFor(event.target.name);
    this.customValidate();
  };
  /***** handle all category add and remove  */
  handleChange(i, e) {
    let formValues = this.state.formValues;
    formValues[i][e.target.name] = e.target.value;
    this.setState({ formValues });
  }
  addFormFields() {
    this.setState(
      {
        formValues: [
          ...this.state.formValues,
          { category_name: "", task_name: [{ task_name: "" }] },
        ],
      },
      () => {
        // Focus on the first ReactQuill of the newly added category
        const lastCategoryIndex = this.state.formValues.length - 1;
        if (
          this.quillRefs[lastCategoryIndex] &&
          this.quillRefs[lastCategoryIndex][0]
        ) {
          this.quillRefs[lastCategoryIndex][0].getEditor().focus();
        }
      }
    );
  }
  removeFormFields(i) {
    this.setState({ deleteCategoryModal: true, pendingDeleteCategory: i });
  }
  closeDeleteCategoryModal() {
    this.setState({ deleteCategoryModal: false, pendingDeleteCategory: null });
  }
  confirmDeleteCategory() {
    const i = this.state.pendingDeleteCategory;
    if (i === null || i === undefined) {
      this.closeDeleteCategoryModal();
      return;
    }
    let formValues = this.state.formValues;
    formValues.splice(i, 1);
    this.setState({ formValues });
    this.closeDeleteCategoryModal();
  }
  handleChangeTaskExclude(k, f, l) {
    if (l.target.name === "is_exclude" && l.target.checked) {
      this.setState({ excludeTaskModal: true, pendingExcludeTask: { k, f } });
      return;
    }
    let formValues = this.state.formValues;
    if (l.target.name === "is_exclude") {
      formValues[k].task_name[f].is_exclude = l.target.checked;
    } else {
      formValues[k].task_name[f].task_name = l.target.value;
    }
    this.setState({ formValues: formValues });
  }
  closeExcludeTaskModal() {
    this.setState({ excludeTaskModal: false, pendingExcludeTask: null });
  }
  confirmExcludeTask() {
    const pending = this.state.pendingExcludeTask;
    if (!pending) {
      this.closeExcludeTaskModal();
      return;
    }
    let formValues = this.state.formValues;
    formValues[pending.k].task_name[pending.f].is_exclude = true;
    this.setState({ formValues });
    this.closeExcludeTaskModal();
  }
  /* handle all task add and remove */
  handleChangeTask(index, taskIndex) {
    let formValues = [...this.state.formValues];
    formValues[index].task_name[taskIndex].viewMode = true;
    this.setState({ formValues }, () => {
      if (this.quillRefs[index] && this.quillRefs[index][taskIndex]) {
        this.quillRefs[index][taskIndex].getEditor().focus();
      }
    });
  }
  addFormFieldsTask(k, m) {
    this.setState(
      (prevState) => {
        const formValues = [...prevState.formValues];
        formValues[k].task_name.push({ task_name: "", viewMode: true }); 
        return { formValues };
      },
      () => {
        // Focus on the newly added ReactQuill editor
        const lastTaskIndex = this.state.formValues[k].task_name.length - 1;
        if (this.quillRefs[k] && this.quillRefs[k][lastTaskIndex]) {
          this.quillRefs[k][lastTaskIndex].focus();
        }
      }
    );
  }

  removeFormFieldsTask(k, m) {
    this.setState({ deleteTaskModal: true, pendingDeleteTask: { k, m } });
  }
  closeDeleteTaskModal() {
    this.setState({ deleteTaskModal: false, pendingDeleteTask: null });
  }
  confirmDeleteTask() {
    const pending = this.state.pendingDeleteTask;
    if (!pending) {
      this.closeDeleteTaskModal();
      return;
    }
    let formValues = this.state.formValues;
    formValues[pending.k].task_name.splice(pending.m, 1);
    this.setState({ formValues });
    this.closeDeleteTaskModal();
  }
  async componentDidMount() {
    this.getProperty();
    this.getTemplateExist();
    if (this.state.slug !== undefined) {
      var resData = {};
      var resDatalist = {};
      let res = await ChecklistService.getChecklistRowBySlug(this.state.slug);
      if (global.successStatus.includes(res.status)) {
        resData = res.data ? res.data : {};
        resDatalist = resData.data ? resData.data : {};
        resData.checklist_name = resDatalist.checklist_name
          ? resDatalist.checklist_name
          : "";
        resData.property_slug = resDatalist.property
          ? resDatalist.property.slug
          : "";
        resData.zone_type = resDatalist.zone
          ? resDatalist.zone.zone_type_id
          : "";
        resData.description = resDatalist.description
          ? resDatalist.description
          : "";
        resData.showWeightInput = resDatalist?.is_enable_weight == 1 ? true : false;
        resData.formValues = resDatalist.category
          ? resDatalist.category.map((category) => ({
              category_name: category.category_name,
              slug: category.slug,
              checklist_cate_id: category.checklist_cate_id,
              task_name: category.task_name.map((task) => ({
                slug: task.slug,
                task_name: task.task_name,
                viewMode: false,
                weight_score: task.weight_score || "",
                 is_exclude: task.is_exclude,
              })),
            }))
          : "";
        resData.status_id = resDatalist.status_id === 1 ? true : false;
        resData.is_checklist = resDatalist.is_checklist
          ? resDatalist.is_checklist
          : "";
        resData.created_by = resDatalist.created_by
          ? resDatalist.created_by.slug
          : "";

        
          this.setState({riskConfigData : resDatalist?.config_data});
          if(resDatalist?.is_risk_level_enable == 1) {
            resData.allowRiskLevelConfig = true;
            this.setState({showRiskLevelInfo : true});
          }
      }
      let zoneType = parseInt(res.data.data.zone.zone_type_id);
      let selectedZoneTypeList = [];
      global.templateOrCheckListzoneTypeList.forEach((item, i) => {
        if (parseInt(item.value) === zoneType) {
          selectedZoneTypeList = [
            {
              value: item.value,
              label: item.label,
            },
          ];
          return false;
        }
      });
      let propertyListData = [];
      propertyListData = res.data.data.property
        ? [
            {
              value: res.data.data.property.slug,
              label: res.data.data.property.property_name,
            },
          ]
        : "";
      this.setState(resData);
      this.setState({ selectedZoneTypeList: selectedZoneTypeList });
      this.setState({ selectedProperty: propertyListData });
      this.setState({ formValues: resData.formValues });
    } else {
      this.setState({
        formValues: [{ category_name: "", task_name: [{ name: "" }] }],
      });
    }

    this.setState({ zoneTypeList: global.templateOrCheckListzoneTypeList });
    setTimeout(() => {
      this.quillRefs.forEach((refArray, index) => {
        if (Array.isArray(refArray)) {
          refArray.forEach((ref, taskIndex) => {
            if (ref && ref.getEditor) {
              const quill = ref.getEditor();
              quill
                .getModule("toolbar")
                .addHandler("link", () => this.handleLink(index, taskIndex));
              quill.root.addEventListener("click", this.handleLinkClick);
            }
          });
        }
      });
    }, 100);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.currentlyFocusedInput) {
      this.currentlyFocusedInput.focus();
    }
    if (prevState.formValues.length !== this.state.formValues.length) {
      setTimeout(() => {
        this.quillRefs.forEach((refArray, index) => {
          if (Array.isArray(refArray)) {
            refArray.forEach((ref, taskIndex) => {
              if (ref && ref.getEditor) {
                const quill = ref.getEditor();
                quill
                  .getModule("toolbar")
                  .addHandler("link", () => this.handleLink(index, taskIndex));
                quill.root.addEventListener("click", this.handleLinkClick);
              }
            });
          }
        });
      }, 100);
    }
  }

  componentWillUnmount() {
    this.quillRefs.forEach((refArray) => {
      if (Array.isArray(refArray)) {
        refArray.forEach((ref) => {
          if (ref && ref.getEditor) {
            const quill = ref.getEditor();
            quill.root.removeEventListener("click", this.handleLinkClick);
          }
        });
      }
    });
  }

  // componentWillUnmount() {
  //   this.quillRefs.forEach((refArray) => {
  //     if (Array.isArray(refArray)) {
  //       refArray.forEach((ref) => {
  //         if (ref && ref.getEditor) {
  //           const quill = ref.getEditor();
  //           quill.root.removeEventListener("click", this.handleLinkClick);
  //         }
  //       });
  //     }
  //   });
  // }

  handleLink(index, taskIndex) {
    const quill = this.quillRefs[index][taskIndex].getEditor();
    const range = quill.getSelection();
    if (range) {
      this.setState({
        showModal: true,
        range: { index, taskIndex, range },
        url: "",
        text: "",
        isEditing: false,
      });
    }
  }

  handleModalClose() {
    this.setState({
      showModal: false,
      range: null,
      url: "",
      text: "",
      isEditing: false,
    });
  }

  handleModalSubmit(url, text) {
    const { range } = this.state;
    if (range && url && text) {
      const { index, taskIndex, range: quillRange } = range;
      const quill = this.quillRefs[index][taskIndex].getEditor();
      if (quill) {
        quill.deleteText(quillRange.index, quillRange.length);
        quill.insertText(quillRange.index, text, "link", url);
        quill.focus();
        quill.setSelection(quillRange.index + text.length);
      }
    }
    this.setState({
      showModal: false,
      range: null,
      url: "",
      text: "",
      isEditing: false,
    });
  }

  handleLinkClick(event) {
    if (event.target.tagName === "A") {
      event.preventDefault();
      const { range } = this.state;
      if (range) {
        const { index, taskIndex } = range;
        const quill = this.quillRefs[index][taskIndex].getEditor();
        const quillRange = quill.getSelection();
        const url = event.target.getAttribute("href");
        const text = event.target.innerText;

        // Prevent Quill's tooltip from showing
        quill.blur();
        // quill.focus();

        this.setState({
          showModal: true,
          range: { index, taskIndex, range: quillRange },
          url,
          text,
          isEditing: true,
        });
      }
    }
  }

  handleModalRemove() {
    const quill = this.quillRefs[this.state.range.index].getEditor();
    const textLength = quill.getLength();

    // Get the entire content and iterate over each character
    for (let i = 0; i < textLength; i++) {
      const [link] = quill.getFormat(i, 1).link || [];
      if (link) {
        // Remove the link format only, leaving the text intact
        quill.formatText(i, 1, "link", false);
      }
    }

    this.setState({ showModal: false, url: "", text: "", isEditing: false });
  }

  handleChangeQuill(index, taskIndex, value) {
    const formValues = [...this.state.formValues];
    formValues[index].task_name[taskIndex].task_name = value;
    // this.setState({ formValues });
  }

    handleWeightChange = (categoryIndex, taskIndex, value) => {
    // Only allow numbers and empty string
    if (value === "" || /^[0-9\b]+$/.test(value)) {
      const numericValue = value === "" ? "" : parseInt(value, 10);
      // Don't allow values > 100
      if (numericValue === "" || numericValue <= 1000) {
        const formValues = [...this.state.formValues];
        formValues[categoryIndex].task_name[taskIndex].weight_score = numericValue;
        this.setState({ formValues });
      }
    }
  };

  async getTemplateExist() {
    this.setState({ loading: true });
    let inputData = {
      user_slug: this.state.userData.slug ? this.state.userData.slug : "",
      role_id: this.state.userData.role_id ? this.state.userData.role_id : "",
      checklist_slug: this.state.slug ? this.state.slug : "",
    };
    var existData = "";
    let res = await ChecklistService.checkListExist(inputData);
    if (global.successStatus.includes(res.status)) {
      existData = res.data ? res.data : [];
    }
    this.setState({ existData: existData });
  }
  saveOrUpdateTemplate = async (e) => {
    e.preventDefault();
    let inputData = {
      checklist_name: this.state.checklist_name
        ? this.state.checklist_name
        : "",
      property_slug: this.state.property_slug ? this.state.property_slug : "",
      zone_type: this.state.zone_type ? this.state.zone_type : "",
      description: this.state.description ? this.state.description : "",
      property: this.state.property_slug ? this.state.property_slug : "",
      formValues: this.state.formValues ? this.state.formValues : "",
      existData: this.state.existData ? this.state.existData : "",
      status_id: this.state.status_id === true ? 1 : 2,
      is_enable_weight: this.state.showWeightInput ? this.state.showWeightInput : 0,
      is_checklist: 3,
      is_exclude: this.state.is_exclude ? this.state.is_exclude : "",

      is_risk_level_config: this.state.allowRiskLevelConfig ? this.state.allowRiskLevelConfig : 0,
      configData : this.state.configData,
    };
    if (this.validator.allValid() && this.customValidate()) {
      this.setState({ isSubmit: true });
      if (this.state.slug !== undefined) {
        let res = await ChecklistService.createImportedCheckList(
          this.state.slug,
          inputData
        );
        if (global.successStatus.includes(res.status)) {
          this.setState({
            showAlertModal: true,
            alertModalType: "success",
            alertModalTitle: "Success",
            alertModalMessage: res.message ? res.message : "Success",
          });
          setTimeout(
            () => this.props.history.push("/checklists"),
            global.redirect_time
          );
        } else {
          let alertMessage = "";
          if (res.data.result.errorDetail !== null) {
            let errors = {};
            res.data.errorCode = "Validation Failed";
            res.data.result.errorDetail.forEach((item) => {
              errors[item.errorField] = item.errorMessage[0];
              res.data.errorMessage = "";
            });
            this.setState({ errors: errors });
          }
          this.setState({
            showAlertModal: true,
            alertModalType: "error",
            alertModalTitle: res.data.message ? res.data.message : "Error!",
            alertModalMessage:
              alertMessage !== "" ? alertMessage : res.data.message,
          });
        }
      }
      this.setState({ isSubmit: false });
      setTimeout(
        () => this.setState({ showAlertModal: false }),
        global.alert_close_time
      );
    } else {
      this.validator.showMessages();
    }
  };
  async deleteChecklist(slug) {
    // alert()
    this.setState({ loading: true, isDelete: true });
    let res = await ChecklistService.deleteCheckList(slug);
    if (global.successStatus.includes(res.status)) {
      this.closedeleteModal();
      this.setState({
        showAlertModal: true,
        alertModalType: "success",
        alertModalTitle: "Success",
        alertModalMessage: res.message ? res.message : "Success",
      });
      setTimeout(
        () => this.props.history.push("/checklists"),
        global.redirect_time
      );
    } else {
      this.closedeleteModal();
      let alertMessage = "";
      this.setState({
        showAlertModal: true,
        alertModalType: "error",
        alertModalTitle: res.data.message ? res.data.message : "Error!",
        alertModalMessage:
          alertMessage !== "" ? alertMessage : res.data.message,
      });
    }
    this.setState({ loading: false, isDelete: false });
    setTimeout(
      () => this.setState({ showAlertModal: false }),
      global.alert_close_time
    );
  }
  closedeleteModal() {
    this.setState({ deleteModal: false });
  }
  opendeleteModal(slug) {
    this.setState({ deleteModal: true });
  }
  //property type handle
  handleChangeProperty(value) {
    let property_slug = [];
    if (value != null && value.length > 0) {
      value.forEach((item, i) => {
        property_slug.push(item.value);
      });
    }
    this.setState({
      selectedProperty: value,
      property_slug: value.value,
    });
  }
  //zone type handle
  handleChangeZoneType(value) {
    let zone_type = [];
    if (value != null && value.length > 0) {
      value.forEach((item, i) => {
        zone_type.push(item.value);
      });
    }
    this.setState({
      selectedZoneTypeList: value,
      zone_type: value.value,
    });
  }
  handleInputFocus = (event) => {
    // console.log(event.target.name);
    if (event.target && event.target.name === "checklist_name") {
      this.currentlyFocusedInput = event.target;
    } else if (event.target && event.target.name === "category_name") {
      this.currentlyFocusedInput = event.target;
    } else if (event.target && event.target.name === "description") {
      this.currentlyFocusedInput = event.target;
    } else if (event.target && event.target.name === "weight_score") {
      this.currentlyFocusedInput = event.target;
    }
  };

  modifyTaskName(taskName) {
    // Create a temporary element to manipulate the HTML string
    const tempElement = document.createElement("div");
    tempElement.innerHTML = taskName;

    // Find all links in the element
    const links = tempElement.querySelectorAll("a");
    links.forEach((link) => {
      link.setAttribute("target", "_blank");
    });

    // Return the modified HTML
    return tempElement.innerHTML;
  }
  render() {
    const customStyles = {
      option: (provided, state) => ({
        ...provided,
        color:
          state.isSelected && state.isFocused
            ? "white"
            : state.isSelected
            ? "black"
            : state.isFocused && "white",
        backgroundColor:
          state.isSelected && state.isFocused
            ? "gray"
            : state.isFocused && "gray",
        fontFamily: "Roboto-Regular",
        fontSize: "16px",
      }),
    };
    const modules = (toolbarId, handleLink) => ({
      toolbar: {
        container: `#${toolbarId}`,
        handlers: {
          link: function (value) {
            if (value) {
              const range = this.quill.getSelection();
              if (range) {
                handleLink(); // Call the handleLink function passed as a prop
              }
            } else {
              this.quill.format("link", false);
            }
          },
        },
      },
    });

    return (
      <main>
        <div className="container-fluid">
          <div className="row row-xs">
            <div className="col-md-12">
              <div className="dashbaord-pageHeadertitle heading_alignment">
                <h3 className="flex-column">
                  <div className="d-flex justify-content-between align-items-center w-100">
                    Import Checklist
                    <Link to="/checklists">
                      <img src={back} alt="" />
                      Back
                    </Link>
                  </div>
                  <span> Add checklist</span>
                </h3>
              </div>
            </div>
          </div>
          <div className="col-md-12 pl-0 pr-0">
            <Alerts
              show={this.state.showAlertModal}
              type={this.state.alertModalType}
              title={this.state.alertModalTitle}
              message={this.state.alertModalMessage}
            />
          </div>
        </div>
        <div className="container-fluid">
          <div className="d-flex flex-column">
            <div className="row row-xs mg-t-0 pd-t-0">
              <div className="col-md-12">
                <div className="scrolling-carousel p-0">
                  <div className="dashboardRightcard m-0">
                    <div className="mg-t-0 mg-b-0">
                      <div className="az-content-label titleLable">Info</div>
                      <div className="row align-items-basline flex-wrap m-0 pd-t-0 pd-b-0 pd-l-70 pd-r-70">
                        <div className="col-md-6 col-lg-6 mg-t-5 mg-md-t-0 mg-b-15 pd-b-1 pd-l-70 pd-r-70">
                          <label className="form-label mg-b-5">Template</label>
                          <Form.Control
                            onChange={this.changeHandler}
                            name="checklist_name"
                            value={this.state.checklist_name ?? ""}
                            className="form-control max_width_100"
                            type="text"
                            onFocus={(e) => this.handleInputFocus(e)}
                          />
                          {this.state.errors.checklist_name ? (
                            <div className="text-danger">
                              {this.state.errors.checklist_name}
                            </div>
                          ) : (
                            this.validator.message(
                              "checklist_name",
                              this.state.checklist_name,
                              "required",
                              { className: "text-danger" }
                            )
                          )}
                        </div>
                        <div className="col-md-6 col-lg-6 mg-t-5 mg-md-t-0 mg-b-15 pd-b-1 pd-l-70 pd-r-70">
                          <label className="form-label mg-b-5">Property</label>

                          <Select
                            className="multiselect new_drop"
                            menuPlacement="auto"
                            value={this.state.selectedProperty ?? []}
                            options={this.state.propertyList}
                            isSearchable={true}
                            onChange={(value) =>
                              this.handleChangeProperty(value)
                            }
                            defaultValue={this.state.selectedProperty}
                            autoComplete="off"
                            getOptionValue={(option) => `${option.label}`}
                            styles={customStyles}
                            theme={(theme) => ({
                              ...theme,
                              colors: {
                                ...theme.colors,
                                primary75: "#808080",
                                primary50: "#808080",
                                primary25: "#808080",
                              },
                            })}
                          />
                          {this.state.errors.property_slug ? (
                            <div className="text-danger">
                              {this.state.errors.property_slug}
                            </div>
                          ) : (
                            this.validator.message(
                              "property list",
                              this.state.property_slug,
                              "required",
                              { className: "text-danger" }
                            )
                          )}
                        </div>
                      </div>
                      <div className="row align-items-basline flex-wrap m-0 pd-t-0 pd-b-0 pd-l-70 pd-r-70">
                        <div className="col-md-6 col-lg-6 mg-t-5 mg-md-t-0 mg-b-15 pd-b-1 pd-l-70 pd-r-70">
                          <label className="form-label mg-b-5">Zone</label>
                          <Select
                            className="multiselect new_drop"
                            menuPlacement="auto"
                            value={this.state.selectedZoneTypeList ?? []}
                            options={this.state.zoneTypeList}
                            isSearchable={true}
                            onChange={(value) =>
                              this.handleChangeZoneType(value)
                            }
                            defaultValue={this.state.selectedZoneTypeList}
                            autoComplete="off"
                            getOptionValue={(option) => `${option.label}`}
                            styles={customStyles}
                            theme={(theme) => ({
                              ...theme,
                              colors: {
                                ...theme.colors,
                                primary75: "#808080",
                                primary50: "#808080",
                                primary25: "#808080",
                              },
                            })}
                          />
                          {this.state.errors.zone_type ? (
                            <div className="text-danger">
                              {this.state.errors.zone_type}
                            </div>
                          ) : (
                            this.validator.message(
                              "zone type list",
                              this.state.zone_type,
                              "required",
                              { className: "text-danger" }
                            )
                          )}
                        </div>
                        <div className="col-md-6 col-lg-6 mg-t-5 mg-md-t-0 mg-b-15 pd-b-1 pd-l-70 pd-r-70">
                          <label className="form-label mg-b-5">
                            Description (Optional)
                          </label>
                          <Form.Control
                            onChange={this.changeHandler}
                            autoComplete="off"
                            name="description"
                            value={this.state.description ?? ""}
                            type="textarea"
                            as="textarea"
                            maxLength="500"
                            placeholder="Type here..."
                            onFocus={(e) => this.handleInputFocus(e)}
                          />
                        </div>
                        <div className="col-md-6 col-lg-6 mg-t-5 mg-md-t-0 mg-b-15 pd-b-1 pd-l-70 pd-r-70">
                          <div className="task-item pl-2 bg-white">
                            <label className="check_cust audit-temp-checkbox mb-0">
                              <input
                                type="checkbox"
                                checked={this.state.showWeightInput}
                                onChange={() =>
                                  this.setState({ showWeightInput: !this.state.showWeightInput, showRiskLevelInfo:false, allowRiskLevelConfig:false })
                                }
                                 className="form-check-input"
                              />
                              Enable Score
                              <span className="checkmark"></span>
                            </label>

                            {this.state.showWeightInput &&
                              <div className="pd-l-70">
                                <label className="check_cust audit-temp-checkbox mb-0">
                                  <input
                                    type="checkbox"
                                    checked={this.state.allowRiskLevelConfig}
                                    onChange={(e) =>
                                      this.setState({
                                        allowRiskLevelConfig: e.target.checked,
                                        showRiskLevelInfo: e.target.checked,
                                      })
                                    }
                                    className="form-check-input"
                                  />
                                  Enable Risk Level
                                  <span className="checkmark"></span>
                                </label>
                              </div>
                            }
                          </div>
                        </div>
                        {this.state.showRiskLevelInfo &&
                          <div className="col-md-12 col-lg-12 mg-t-5 mg-md-t-0 mg-b-15 pd-b-1 pd-l-70 pd-r-70">
                            <RiskLevelConfig onChange={this.handleConfigChange} rowData={this.rowData.bind(this)} riskConfigData={this.state.riskConfigData} />
                          </div>
                        }
                      </div>
                      <hr className="mg-t-20 mg-b-20 pd-t-1 pd-b-3" />
                      <div className="row align-items-basline flex-wrap m-0 pd-t-0 pd-b-0 pd-l-30 pd-r-20">
                        <div className="col-md-6 col-lg-6 mg-t-5 mg-md-t-0 mg-b-15 pd-b-1 pd-r-0 pl-0">
                          <div className="az-content-label titleLable pl-0">
                            <span className="pd-t-10 d-block">Tasks</span>
                          </div>
                        </div>
                        {global.userPermissions.checkPermission(
                          "checklist-update"
                        ) && (
                          <div className="col-lg-3 float-right p-0">
                            <button
                              type="button"
                              className="gf-btn-lg-stroke float-right mr-0 button "
                              onClick={() => this.addFormFields()}
                            >
                              add category
                            </button>
                          </div>
                        )}
                      </div>

                      {this.state.formValues.map((element, index) => (
                        <div
                          className="row align-items-basline flex-wrap m-0 pd-t-0 pd-b-0 pd-l-70 pd-r-20"
                          key={index}
                        >
                          <div className="col-md-9 col-lg-9 mg-t-5 mg-md-t-0 mg-b-15 pd-b-1 pd-l-70 pd-r-0">
                            <label className="form-label text-left mg-b-5">
                              Category
                            </label>
                            <Form.Control
                              name="category_name"
                              className="form-control max_width_100"
                              type="text"
                              autoComplete="off"
                              onFocus={(e) => this.handleInputFocus(e)}
                              value={
                                element.category_name !== ""
                                  ? element.category_name
                                  : ""
                              }
                              onChange={(e) => this.handleChange(index, e)}
                            />
                          </div>
                          <div className="col-lg-3 align-items-center d-flex">
                            {index ? (
                              <button
                                type="button"
                                className="button deleteCat"
                                onClick={() => this.removeFormFields(index)}
                              >
                                <img src={deleteicon} alt="Delete" />
                              </button>
                            ) : null}
                          </div>
                          <div className="col-md-8 col-lg-8 mg-t-5 mg-md-t-0 pd-l-70 pd-r-10">
                            <label className="form-label text-left pd-l-70 mb-0">
                              Task
                            </label>
                          </div>
                          <div className="col-md-1 col-lg-1 mg-t-5 mg-md-t-0 pd-b-1 ">
                            <label className="form-label  mg-b-5 pd-l-20">
                              Exclude
                            </label>
                          </div>
                          {element.task_name !== undefined &&
                            element.task_name.map((el, indexes) => {
                              const toolbarId = `toolbar-${index}-${indexes}`;
                              return (
                                <div
                                  className="row align-items-basline flex-wrap m-0 pd-t-0 pd-b-0 pd-l-70 pd-r-0 w-100"
                                  key={indexes}
                                >
                                  <div className="col-md-8 col-lg-8 mg-t-5 mg-md-t-0 mg-b-15 pd-b-1 pd-l-70 pd-r-10">
                                    <label className="form-label text-left mg-b-0"></label>
                                    {el.viewMode == false ? (
                                      <>
                                      <span
                                        dangerouslySetInnerHTML={{
                                          __html: this.modifyTaskName(
                                            el.task_name ? el.task_name : ""
                                          ),
                                        }}
                                        className="task-name-span text_para_inn"
                                        onClick={() =>
                                          this.handleChangeTask(index, indexes)
                                        }
                                      />
                                      {this.state.showWeightInput ? (
                                          <div className="col-md-12 col-lg-12 mg-t-15 pd-b-1 pd-l-0 pd-r-0">
                                            <label className="form-label mg-b-5">Possible Score</label>
                                            <input
                                              type="text"
                                              className="form-control"
                                              name="weight_score"
                                              value={el.weight_score || ""}
                                              onChange={(l) => this.handleWeightChange(index, indexes, l.target.value)}
                                              onKeyDown={(e) => {
                                                e.stopPropagation(); // Stop key events from reaching the editor
                                                // Prevent non-numeric input
                                                if (!/[0-9]|Backspace|Delete|ArrowLeft|ArrowRight/.test(e.key)) {
                                                  e.preventDefault();
                                                }
                                              }}
                                              onClick={(e) => e.stopPropagation()} // Prevent click events from reaching the editor
                                              onFocus={(e) => this.handleInputFocus(e)}
                                              onBlur={(e) => {
                                                // Ensure value is between 0-100 when leaving field
                                                if (e.target.value !== "" && isNaN(parseFloat(e.target.value))) {
                                                const formValues = [...this.state.formValues];
                                                formValues[index].task_name[indexes].weight = "";
                                                this.setState({ formValues });
                                                }
                                            }}
                                            />
                                          </div>
                                        ) : null}
                                        </>
                                    ) : (
                                      <>
                                        <div id={toolbarId}>
                                           <select className="ql-color" />
                                          <button className="ql-bold"></button>
                                          <button className="ql-italic"></button>
                                          <button className="ql-underline"></button>
                                          <button className="ql-link"></button>
                                        </div>
                                        <ReactQuill
                                          key={`${index}-${indexes}`}
                                          ref={(el) => {
                                            if (!this.quillRefs[index])
                                              this.quillRefs[index] = [];
                                            this.quillRefs[index][indexes] = el;
                                          }}
                                          theme="snow"
                                          name="task_name"
                                          value={el.task_name ?? ""}
                                          onChange={(l) =>
                                            this.handleChangeQuill(
                                              index,
                                              indexes,
                                              l
                                            )
                                          }
                                          modules={modules(toolbarId, () =>
                                            this.handleLink(index, indexes)
                                          )}
                                          formats={global.formats}
                                          className="custom_editor_style"
                                        />
                                        {this.state.showModal && (
                                          <LinkModal
                                            onClose={this.handleModalClose}
                                            onSubmit={this.handleModalSubmit}
                                            onRemove={this.handleModalRemove}
                                            url={this.state.url}
                                            text={this.state.text}
                                            isEditing={this.state.isEditing}
                                            showModal={this.state.showModal}
                                          />
                                        )}
                                        {this.state.showWeightInput && (
                                        <div className="col-md-12 col-lg-12 mg-t-15 pd-b-1 pd-l-0 pd-r-0">
                                          <label className="form-label mg-b-5">Possible Score</label>
                                          <input
                                            type="text"
                                            className="form-control"
                                            name="weight_score"
                                            value={el.weight_score || ""}
                                            onChange={(l) => this.handleWeightChange(index, indexes, l.target.value)}
                                            onKeyDown={(e) => {
                                              e.stopPropagation(); // Stop key events from reaching the editor
                                              // Prevent non-numeric input
                                              if (!/[0-9]|Backspace|Delete|ArrowLeft|ArrowRight/.test(e.key)) {
                                                e.preventDefault();
                                              }
                                            }}
                                            onClick={(e) => e.stopPropagation()} // Prevent click events from reaching the editor
                                            onFocus={(e) => this.handleInputFocus(e)}
                                            onBlur={(e) => {
                                                // Ensure value is between 0-100 when leaving field
                                                if (e.target.value !== "" && isNaN(parseFloat(e.target.value))) {
                                                const formValues = [...this.state.formValues];
                                                formValues[index].task_name[indexes].weight = "";
                                                this.setState({ formValues });
                                                }
                                            }}
                                          />
                                        </div>
                                      )}
                                      </>
                                    )}
                                  </div>
                                  
                                  <div className="col-md-3 col-lg-3 mg-t-5 mg-md-t-0 mg-b-15 pd-b-1 pd-t-10 text-left d-flex audit_check_box ">
                                    <label className="check_cust audit-temp-checkbox">
                                      <input
                                        type="checkbox"
                                        name="is_exclude"
                                        onChange={(l) =>
                                          this.handleChangeTaskExclude(
                                            index,
                                            indexes,
                                            l
                                          )
                                        }
                                        checked={!!el.is_exclude}
                                      />
                                      <span className="checkmark"></span>
                                    </label>
                                  <div className="audit-custom-BtnBox">
                                  {indexes  === element.task_name.length - 1  ? (
                                      <button
                                      className="button addCat new_btn_add"
                                      type="button"
                                      onClick={() =>
                                        this.addFormFieldsTask(
                                          index,
                                          indexes
                                        )
                                      }
                                    >
                                      <img src={pluswIcon} alt="Add" />{" "}
                                    </button>
                                    ) : ''}
                                    {indexes <= 0 ? (
                                      <div className="add_btn_fst">
                                        {/* <button
                                          className="button addCat new_btn_add"
                                          type="button"
                                          onClick={() =>
                                            this.addFormFieldsTask(
                                              index,
                                              indexes
                                            )
                                          }
                                        >
                                          <img src={pluswIcon} alt="Add" />{" "}
                                        </button> */}
                                        <button
                                          type="button"
                                          className="button deleteCat new_btn_add"
                                          onClick={() =>
                                            this.removeFormFieldsTask(
                                              index,
                                              indexes
                                            )
                                          }
                                        >
                                          <img src={deleteicon} alt="Delete" />
                                        </button>
                                        {this.state.slug !== undefined ? (
                                          <button
                                            className="button addCat new_btn_add"
                                            type="button"
                                            onClick={() =>
                                              this.handleChangeTask(
                                                index,
                                                indexes
                                              )
                                            }
                                          >
                                            <img src={EditpenIcon} alt="Add" />{" "}
                                          </button>
                                        ) : (
                                          ""
                                        )}
                                      </div>
                                    ) : (
                                      <div>
                                        <button
                                          type="button"
                                          className="button deleteCat new_btn_add"
                                          onClick={() =>
                                            this.removeFormFieldsTask(
                                              index,
                                              indexes
                                            )
                                          }
                                        >
                                          <img src={deleteicon} alt="Delete" />
                                        </button>
                                        <button
                                          className="button addCat new_btn_add"
                                          type="button"
                                          onClick={() =>
                                            this.handleChangeTask(
                                              index,
                                              indexes
                                            )
                                          }
                                        >
                                          <img src={EditpenIcon} alt="Add" />{" "}
                                        </button>
                                      </div>
                                    )}
                                    </div>
                                  </div>
                                </div>
                              );
                            })}
                        </div>
                      ))}

                      <div className="row align-items-basline flex-wrap m-0 pd-b-0 pd-l-70 padding-right-72">
                        <div className="col-md-10 col-lg-10 mg-t-5 mg-md-t-0 mg-b-15 pd-b-1 pd-l-70 pd-r-70 d-flex align-items-center justify-content-between ">
                          <div className="pd-l-70 excluded_box">
                            <p>
                              {" "}
                              <span className="excluded_icon">!</span> Excluded
                              tasks will not be included in scoring.
                            </p>
                          </div>
                        </div>
                        <div className="col-md-10 col-lg-10 mg-t-5 mg-md-t-0 mg-b-15 pd-b-1 pd-l-70 pd-r-70 d-flex align-items-center justify-content-between ">
                          <div className="d-flex align-items-center justify-content-start">
                            <label className="form-label text-left mg-b-0">
                              {this.state.status_id ? "Active" : "Inactive"}{" "}
                            </label>
                            <div
                              className={
                                this.state.status_id
                                  ? "az-toggle on"
                                  : "az-toggle"
                              }
                              onClick={() =>
                                this.setState({
                                  status_id: !this.state.status_id,
                                })
                              }
                            >
                              <span></span>
                            </div>
                          </div>
                          {global.userPermissions.checkPermission(
                          "checklist-update"
                        ) && (
                          <div className="col-lg-3 float-right p-0">
                            <button
                              type="button"
                              className="gf-btn-lg-stroke float-right mr-0 button "
                              onClick={() => this.addFormFields()}
                            >
                              add category
                            </button>
                          </div>
                        )}
                        </div>
                      </div>
                      <div className="row row-xs align-items-center flex-wrap m-0 pd-t-30 pd-b-0 pd-l-80 pd-r-95">
                        <div className="col-md-10 btnNavigate d-flex align-items-center justify-content-between flex-row flex-wrap-bothBtn p-0">
                          {global.userPermissions.checkPermission(
                            "checklist-delete"
                          ) &&
                            (this.state.slug !== undefined &&
                            this.state.is_checklist !== 1 ? (
                              <>
                                {this.state.created_by ===
                                global.userData.slug && global.userData.role_id !== 1 ? (
                                  <>
                                    <button
                                      type="button"
                                      className="detlet-text mg-r-20 pl-0"
                                      onClick={() => {
                                        this.opendeleteModal(
                                          this.state.propertySlug
                                        );
                                      }}
                                    >
                                      Delete Checklist
                                    </button>
                                  </>
                                ) : (
                                 ''
                                )}
                                {global.userData.role_id === 1 ? (
                                  <>
                                    <button
                                      type="button"
                                      className="detlet-text mg-r-20 pl-0"
                                      onClick={() => {
                                        this.opendeleteModal(
                                          this.state.propertySlug
                                        );
                                      }}
                                    >
                                      Delete Checklist
                                    </button>
                                  </>
                                ) : (
                                  <span className="invisible">
                                    Delete Template System
                                  </span>
                                )}
                              </>
                            ) : (
                              <span className="invisible">Delete Template</span>
                            ))}
                          <div className="d-flex align-items-center pd-r-65">
                            <Link to="/checklists">
                              {" "}
                              <button
                                type="button"
                                className="gf-btn-lg-outline mg-r-7"
                              >
                                {" "}
                                Cancel{" "}
                              </button>
                            </Link>
                            {this.state.slug == undefined &&
                              global.userPermissions.checkPermission(
                                "checklist-add"
                              ) && (
                                <button
                                  type="button"
                                  onClick={this.saveOrUpdateTemplate}
                                  className="gf-btn-lg-stroke mg-l-2"
                                >
                                  {" "}
                                  {this.state.isSubmit ? global.loader : "ADD"}
                                </button>
                              )}
                            {this.state.slug !== undefined &&
                              global.userPermissions.checkPermission(
                                "checklist-update"
                              ) && (
                                <button
                                  type="button"
                                  onClick={this.saveOrUpdateTemplate}
                                  className="gf-btn-lg-stroke mg-l-2"
                                >
                                  {" "}
                                  {this.state.isSubmit
                                    ? global.loader
                                    : "Update"}
                                </button>
                              )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="ht-50"></div>
            </div>
          </div>
        </div>
        <Modal show={this.state.deleteModal} centered>
          <Modal.Body className="width_402 p-4 border_radius_14">
            <div className="text-center">
              {/* <img src={modaldeleteicon} alt="modal-delete-icon" /> */}
              <h3>Delete Checklist?</h3>
              <p className="pd-l-50 pd-r-50 pd-b-20 model_first_p">
                Do you really want to delete this checklist? This process cannot
                be undone.
              </p>
              <div className="d-flex cnt_center mt-3 row">
                <button
                  type="button"
                  className="m-0 btn btn-outline-light btn-block"
                  onClick={() => this.closedeleteModal()}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="m-0 btn btn btn-danger btn-block"
                  onClick={() => this.deleteChecklist(this.state.slug)}
                  // disabled={this.state.isSubmit ? true : false}
                  disabled={this.state.isDelete ? true : false}
                >
                  {this.state.isDelete ? global.loader : "Delete"}
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
        <Modal show={this.state.deleteCategoryModal} centered>
          <Modal.Body className="width_402 p-4 border_radius_14">
            <div className="text-center">
              <h3>Delete Category?</h3>
              <p className="pd-l-50 pd-r-50 pd-b-20 model_first_p">
                Are you sure you want to delete this category? All tasks
                under it will also be removed. This process cannot be undone.
              </p>
              <div className="d-flex cnt_center mt-3 row">
                <button
                  type="button"
                  className="m-0 btn btn-outline-light btn-block"
                  onClick={() => this.closeDeleteCategoryModal()}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="m-0 btn btn btn-danger btn-block"
                  onClick={() => this.confirmDeleteCategory()}
                >
                  Delete
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
        <Modal show={this.state.deleteTaskModal} centered>
          <Modal.Body className="width_402 p-4 border_radius_14">
            <div className="text-center">
              <h3>Delete Task?</h3>
              <p className="pd-l-50 pd-r-50 pd-b-20 model_first_p">
                Are you sure you want to delete this task? This process cannot
                be undone.
              </p>
              <div className="d-flex cnt_center mt-3 row">
                <button
                  type="button"
                  className="m-0 btn btn-outline-light btn-block"
                  onClick={() => this.closeDeleteTaskModal()}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="m-0 btn btn btn-danger btn-block"
                  onClick={() => this.confirmDeleteTask()}
                >
                  Delete
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
        <Modal show={this.state.excludeTaskModal} centered>
          <Modal.Body className="width_402 p-4 border_radius_14">
            <div className="text-center">
              <h3>Exclude Task?</h3>
              <p className="pd-l-50 pd-r-50 pd-b-20 model_first_p">
                Are you sure you want to exclude this task?
              </p>
              <div className="d-flex cnt_center mt-3 row">
                <button
                  type="button"
                  className="m-0 btn btn-outline-light btn-block"
                  onClick={() => this.closeExcludeTaskModal()}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="m-0 btn btn btn-danger btn-block"
                  onClick={() => this.confirmExcludeTask()}
                >
                  Exclude
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </main>
    );
  }
}

export default ChecklistForm;
